<template>
  <div v-if="isLoading && !isLoadingPrincipal" id="loadding-personalizado">
    <div id="div-center">
      <div id="um" class="barra"></div>
      <div id="dois" class="barra"></div>
      <div id="tres" class="barra"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      isLoading: "loadingAux/loading"
    }),
    isLoadingPrincipal() {
      return this.$store.state.loading.isLoading;
    },
  },
};
</script>

<style scoped>
#loadding-personalizado {
  position: absolute;
  min-height: 100vh;
  min-width: 100%;
  background-color: rgba(255, 255, 255, .4);
  display: flex;
  align-items: center;
}
#div-center {
  display: flex;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
}
.barra {
  margin: 15px;
  background: #042333;
  width: 20px;
}
#loadding-personalizado #div-center #um {
  animation: um 0.3s alternate infinite;
}
#loadding-personalizado #div-center #dois {
  animation: dois 0.32s alternate infinite;
}
#loadding-personalizado #div-center #tres {
  animation: tres 0.3s alternate infinite;
}

@keyframes um {
  0% {
    height: 20px;
  }
  50% {
    height: 60px;
  }
  100% {
    height: 100px;
  }
}
@keyframes dois {
  0% {
    height: 20px;
  }
  50% {
    height: 60px;
  }
  100% {
    height: 100px;
  }
}
@keyframes tres {
  0% {
    height: 110px;
  }
  50% {
    height: 70px;
  }
  100% {
    height: 30px;
  }
}
</style>
